// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___ZIsr8","m-signature-pad--body":"styles__m-signature-pad--body___3MzSR","m-signature-pad--footer":"styles__m-signature-pad--footer___1gXpn","description":"styles__description___3iQTb","button":"styles__button___3AI0m","clear":"styles__clear___22Q9d","save":"styles__save___6Ghxj","m-signature-pad":"styles__m-signature-pad___1Dtx3","github":"styles__github___3Pvmd","input-icon":"styles__input-icon___12KQZ","dollarSign":"styles__dollarSign___tGelQ"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/CurrencyInput/styles.scss
// module id = IfL0
// module chunks = client